<template>
    <v-dialog v-model="shows" max-width="480" :persistent="loading">
        <template #activator="{ attrs, on }">
            <slot name="default" v-bind="{ attrs, on }" />
        </template>
        <v-card class="v-card--dialog">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">주문 상태</h3>
                <v-btn fab color="transparent" @click="exit" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body page-text text-center">
                <nshop-order-view-table v-bind="{ value }" />
            </div>
            <div class="v-card--dialog__foot" v-if="showsStop">
                <v-row class="row--x-small" justify="center">
                    <v-col cols="auto">
                        <v-btn v-bind="{ loading }" color="primary" @click="stop">주문취소</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { initNshopOrder } from "@/store/nshop";
import NshopOrderViewTable from "../../nshop/order/nshop-order-view-table.vue";

export default {
    components: {
        NshopOrderViewTable,
    },
    props: {
        /** @type {import('vue').PropType<import('@/store/nshop').NshopOrder>} */
        value: { type: Object, default: initNshopOrder },
    },
    data: () => ({
        shows: false,
        loading: false,
    }),
    computed: {
        showsStop() {
            return this.value.state === "ORDER_INIT";
        },
    },
    methods: {
        exit() {
            if (this.loading) return;
            this.shows = false;
        },
        async stop() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { order } = await api.v1.me.nshop.orders.stop.post(this.value);
                this.$emit("input", initNshopOrder(order));
                alert("주문이 취소되었습니다.");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.nshop-order-item-state-table {
    &,
    ::v-deep *,
    ::v-deep td {
        font-size: 14px !important;
        line-height: 1.25 !important;
    }

    ::v-deep colgroup {
        display: none;
    }
    ::v-deep table {
        border-bottom: none !important;
    }
    ::v-deep .white-space-pre-line {
        white-space: pre-line;
    }
}
</style>
